import Vue from 'vue/dist/vue.esm'
import ProductCartForm from 'components/storefront/product-cart-form'

export default function buildProductCartFormApp(element) {
  new Vue({
    el: element,
    components: {
      ProductCartForm
    }
  })
}
